
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import IconTrash from "../common/icon/IconTrash.vue";

@Component({
  name: "user-servicepoints-table-action",
  components: {
    IconTrash,
  },
})
export default class UserServicepointsTableAction extends Vue {
  @Prop({ required: true }) isNotSameUserAndIsAdmin!: boolean;
  @Prop({ required: true }) checkedAll!: boolean;
  @Prop({ required: true }) allDeselect!: boolean;
  @Prop({ required: true }) componentId!: string;

  get selectAllLabel(): string {
    return this.checkedAll
      ? this.$t("label.deselectAll").toString()
      : this.$t("label.selectAll").toString();
  }

  get selectAllAriaLabel(): string {
    return this.checkedAll
      ? this.$t("label.deselectAll").toString()
      : this.$t("action.selectAll").toString();
  }

  selectAll(): void {
    this.$emit("select-all");
  }

  removeServicepoints(): void {
    this.$emit("remove-servicepoints");
  }
}
